// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-header {
  margin-bottom: 2rem;
}

.dashboard-header h1 {
  color: #333;
  margin-bottom: 0.5rem;
}

.dashboard-header p {
  color: #666;
  font-size: 1.1rem;
}

/* Quick Actions */
.quick-actions {
  margin-bottom: 2rem;
}

.quick-actions h2 {
  margin-bottom: 1rem;
  color: #333;
}

.action-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.action-card {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.action-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.action-card.pending {
  border-left-color: #fd7e14;
}

.action-card.expiration {
  border-left-color: #dc3545;
}

.action-card.bookkeepers {
  border-left-color: #007bff;
}

.action-card.zipcodes {
  border-left-color: #6f42c1;
}

.action-card h3 {
  margin-bottom: 0.5rem;
  color: #333;
}

.action-card p {
  color: #666;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.action-card span {
  color: #007bff;
  font-weight: 500;
  font-size: 0.8rem;
}

/* Charts Grid */
.dashboard-charts {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
}

.chart-container {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.chart-container h3 {
  margin-bottom: 1rem;
  color: #333;
  font-size: 1.1rem;
}

@media (max-width: 968px) {
  .dashboard-charts {
    grid-template-columns: 1fr;
  }
  
  .action-cards {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,qCAAqC;EACrC,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;AACF","sourcesContent":[".dashboard {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.dashboard-header {\n  margin-bottom: 2rem;\n}\n\n.dashboard-header h1 {\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.dashboard-header p {\n  color: #666;\n  font-size: 1.1rem;\n}\n\n/* Quick Actions */\n.quick-actions {\n  margin-bottom: 2rem;\n}\n\n.quick-actions h2 {\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.action-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.action-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  text-decoration: none;\n  color: inherit;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n  border-left: 4px solid transparent;\n}\n\n.action-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.action-card.pending {\n  border-left-color: #fd7e14;\n}\n\n.action-card.expiration {\n  border-left-color: #dc3545;\n}\n\n.action-card.bookkeepers {\n  border-left-color: #007bff;\n}\n\n.action-card.zipcodes {\n  border-left-color: #6f42c1;\n}\n\n.action-card h3 {\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.action-card p {\n  color: #666;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.action-card span {\n  color: #007bff;\n  font-weight: 500;\n  font-size: 0.8rem;\n}\n\n/* Charts Grid */\n.dashboard-charts {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 2rem;\n}\n\n.chart-container {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.chart-container h3 {\n  margin-bottom: 1rem;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n@media (max-width: 968px) {\n  .dashboard-charts {\n    grid-template-columns: 1fr;\n  }\n  \n  .action-cards {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
